module.exports = __webpack_public_path__ + "static/medical_society-6f316b8308ea151e08e2e25b9e372b15.jpg";